import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { createBrowserHistory } from 'history';
// Utils
import { Router } from 'react-router-dom';
import configureStore from './config/configStore';

// components
import App from './App';

//css
import './index.css';

const store = configureStore();
const history = createBrowserHistory();

const renderApp = () => render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.querySelector('#root'),
);

renderApp();